import React, { ChangeEvent } from "react";

type FieldInputProps = {
  label: string;
  name: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const FieldInput: React.FC<FieldInputProps> = ({ label, name, value, onChange }) => (
  <div className="col-md-3 col-sm-4 col-12">
    <div className="col-inner">
      <div className="form-group">
        <label className="form-label">{label}</label>
        <input
          type="number"
          name={name}
          className="form-control"
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  </div>
);

export default FieldInput;
